import { get, post } from "api";

// MOVING A PROJECT TO ANOTHER TENANT. Super admin only, enforced on the
// server - these calls are the only way in from the browser.
//
// The preview is the one that matters: it is the only moment anybody sees
// WHICH project is going WHERE, how many rows change hands, which rows stay
// with a partner, and what the receiving tenant is about to be granted.
//
// `choices` is what the dialog has picked so far (2026-10-15):
//   newOwner            account id or email in the receiving company
//   oversight           { members: [{ userId, email, name, lead, permissions }] }
//   departingAsPartner  { supervisors: [{ userId, showCost, jobTitle }], users: [{ userId, jobTitle }] }
// Without an owner and an oversight entry every preview is blocked - which is
// why the first version of this dialog could never transfer anything.
const body = (projectId, toCompanyId, choices = {}) => {
  const out = { projectId, toCompanyId };
  if (choices.newOwner) out.newOwner = choices.newOwner;
  if (choices.oversight) out.oversight = choices.oversight;
  if (choices.departingAsPartner) out.departingAsPartner = choices.departingAsPartner;
  return out;
};

export const previewTransfer = (projectId, toCompanyId, choices) =>
  post("/tenant-transfer/preview", body(projectId, toCompanyId, choices));

// `confirmName` has to be the project's own name, typed. A mis-clicked id is
// a project handed to the wrong company and there is no cheap way back.
export const runTransfer = (projectId, toCompanyId, confirmName, choices) =>
  post("/tenant-transfer/run", { ...body(projectId, toCompanyId, choices), confirmName });

// UNDO RETURNS THE PROJECT TO THE COMPANY IT CAME FROM. The argument is that
// ORIGINAL company - "Undo transfer - return to <company>" - never the one
// it went to; the server refuses the other reading.
export const undoTransfer = (projectId, backToCompanyId) =>
  post("/tenant-transfer/undo", { projectId, backTo: backToCompanyId });

// Accounts of a company a new owner can be picked from, second memberships
// included, searched by name or email.
export const transferPeople = (companyId, q = "") =>
  get(`/tenant-transfer/people?companyId=${encodeURIComponent(companyId)}&q=${encodeURIComponent(q)}`);

// Transfers into this company that can still be undone.
export const undoableTransfers = (companyId) =>
  get(`/tenant-transfer/undoable?companyId=${encodeURIComponent(companyId)}`);
